define([], function () {
    var framework = {
        "title.error": "Error",
        "title.prompt": "Information",
        "title.confirm": "Confirm",
        "title.warn": "Warning",

        "hasBindUniportal": "Your HUAWEI CLOUD account has already been upgraded. Use your HUAWEI ID to log in.",

        "mobileLoginModel.intlIpTip": "Use a mobile number registered on the Chinese mainland to log in to this page.",
        "mobileLoginModel.mobileLogin": "Mobile Number Login",
        "mobileLoginModel.accountLogin": "Account/Email Login",
        "mobileLoginModel.mobilePlaceHolder": "Mobile number",
        "mobileLoginModel.accountPlaceHolder": "Account name or email",
        "mobileLoginModel.userPlaceHolder": "IAM user name or email",
        "mobileLoginModel.notRegisterTip": "Unregistered mobile number. ",
        "mobileLoginModel.isMobileTip": "You appear to have entered a mobile number. Switch to ",
        "mobileLoginModel.registerNow": "Register now",
        "mobileLoginModel.multiUsersTip": "The mobile number is bound to multiple accounts. Select the account you want to use.",
        "mobileLoginModel.operationTooFrequent": "You have tried too many times within a short period. Try again {0} minutes later.",
        "mobileLoginModel.invalidNumber": "Enter a valid mobile number.",
        "mobileLoginModel.retry": "Retry",
        "mobileLoginModel.retrievePwd": "Reset Password",
        "emailLoginModel.multiUsersTip": "The email address is bound to multiple accounts. Select the account you want to use.",   
        "fpwd.multiEmailUsersTip": "The email address is bound to multiple accounts. Select the account for which you want to reset the password.",

        "loginRegistTip":"New users can register by invitation only.",
        "accountName":" Account Name",
        "uniportalTip":"Huawei official website users, Huawei enterprise partners, Huawei employees, and ICT developers",
        "activeAccount":"Activate",
    	"activeAccountMsg":"Dear user, this is your first login to HUAWEI CLOUD. Please read and agree with the HUAWEI CLOUD Customer Agreement and Privacy Statement before you proceed further.",
        "userNameTip":"Username:",
        "searchBoxPlaceHolder": "Enter a keyword.",
        "submitBtnTxt": "OK",
        "cancelBtnTxt": "Cancel",
        "btnTxtOK": "OK",
        "btnTxtCancel": "Cancel",
        "btnTxtYes": "Yes",
        "btnTxtNo": "No",
        "logout": "Exit",
        "connect" : "and",
        "emptyStr": "--",
        "blankTxt": "This field cannot be left blank.",
        "emptyTxt": "This field cannot be left blank or contain spaces.",
        "nameBlankTxt": "This field cannot be left blank.",
        "passwordEqual": "Passwords do not match.",
        "validEmail": "Enter a valid email address.",
        "validPhone": "Enter a valid mobile number.",
        "maxLenTxt": "Enter a maximum of {0} characters.",
        "minLenTxt": "Enter at least {0} characters.",
        "minMaxLenTxt": "Must contain {0}–{1} characters.",
        "phoneMaxLenTxt": "Enter a maximum of {0} digits.",
        "msgCodeErrorInfo": "Only digits are allowed.",
        "nameContainsChar": "Only letters, digits, hyphens (-), and underscores (_) are allowed. The name must start with a letter or hyphen.",
        "commonContainsChar": "Only letters and digits are allowed.",
        "pwdNotUsernameOrInvert": "Cannot be the username or the username spelled backwards.",
        "pwdNotContsMobileOrEmail": "The password cannot contain the mobile number or email address.",
        "pwdNotContsMobile": "The password cannot contain the mobile number.",
        "pwdcantContsMobileOrEmail": "The password cannot contain the mobile number or email address.",
        "pwdWeak":"The password could be leaked. Enter another one. ",
        "usernameNotPwdOrInvert": "The username cannot be the password or the password spelled backwards.",
        "passwordChars": "Must contain at least {0} of the following character types: uppercase letters, lowercase letters, digits, spaces, and special characters (~`!?,.:;-_'\"(){}[]/<>@#$%^&*+|\\=).",
        "mobilePasswordChars1": "The password must contain at least two of the following: ",
        "mobilePasswordChars2": "uppercase letters, lowercase letters, digits, and special characters.",
        "validEmailOrPhone": "Enter a valid email address or mobile number.",
        "validAccountName": "Enter a valid account name.",
        "validPwd": "Enter a valid password.",
        "validAgency": "Enter a valid agent name.",
        "validCheckCode": "Enter a maximum of 4 characters.",
        "tooMuchErrorCode": "You have exceeded the maximum verification code requests allowed. Please try again later.",
        "pwdCannotEqualName": "Cannot be the account name or the account name spelled backwards.",
        "passwordPolicy.errorMsgOfRptChar": "The password can contain a maximum of {0} consecutive identical characters.",
        "inValidCcompanyName": "Cannot contain only special characters, digits, spaces, or tab characters.",
        "companyNameLength": "Enter a maximum of 32 characters.",
        "accountTipInfo":"Your account information:",
        "yes": "Yes",
        "no": "No",
        "iamUserTip": "You can log in as an IAM user if your account has been created by another HUAWEI CLOUD account.",
        "registerFailed": "Registration failed.",
        "recommended": "Recommended",
        "strengthLow": "Weak",
        "strengthMid": "Medium",
        "strengthHigh": "Strong",

        accountNameBlank: "Enter the account name.",
        userNameBlank: "Enter the IAM user name or email address.",
        pwdBlank: "Enter the password.",
        checkCodeBlank: "Enter the verification code.",
        phoneBlank: "Enter the mobile number.",
        checkCodeBlank4Intl: "Enter the verification code.",
        backToHomepage: "Back to Homepage",

        backTo: "Back",
        homepage: "Homepage",
        mobileHome: "Homepage",

        "isHwsUser": "Your account is registered on the HUAWEI CLOUD China website and can only be used there.",
        "isHongKongUser": "Your account is registered on the HUAWEI CLOUD international website and can only be used there.",
        "isRuUser":"Your account is registered on the HUAWEI CLOUD international website and can only be used there.",
        "isHwsUser1": "Your account is registered on the ",
        "isHongKongUser1": "Your account is registered on the ",
        "isRuUser1":"Your account is registered on the ",
        "goLogin.hws": "HUAWEI CLOUD China website",
        "goLogin.hk": "HUAWEI CLOUD international website",
        "goLogin.ru": "HUAWEI CLOUD international website",
        "toLogin.hws": " and can only be used there.",
        "toLogin.hk": " and can only be used there.",
        "toLogin.ru": " and can only be used there.",

        "language": "English",
        "lanuage.hk":"International",
        "lanuage.ch":"中国站",
        "language.zh-cn": "简体中文",
        "language.en-us": "English",

        "titles.login": "HUAWEI CLOUD - Login",
        "titles.resetPwd": "HUAWEI CLOUD - Reset Password",
        "titles.fpwd": "HUAWEI CLOUD - Forgot Password",
        "titles.register": "HUAWEI CLOUD - Register",
        "titles.agencyRegister": "HUAWEI CLOUD - Agent Register",
        "titles.reactivate": "HUAWEI CLOUD - Reactivate",
        "titles.registerSuccess": "HUAWEI CLOUD - Registration Successful",
        "titles.fphone": "HUAWEI CLOUD - Change Mobile Number",
        "titles.loginVerification": "HUAWEI CLOUD - Login Verification",
        "titles.bindAccount": "HUAWEI CLOUD - First Login",
        "titles.bindAccountSuccess": "HUAWEI CLOUD - Registration Successful (Register and Bind)",

        registerFree: "HUAWEI CLOUD Account Registration",
        freeRegister: "Free Registration",
        createDomain : "Create Account",
        createDomainBtn : "Create and Bind",
        createSubUser : "Create Subuser Account",
        createFailed : "Failed to create the account.",
        bindDomain : "Bind Account",
        createDomainLink:"Create Account",
        bindDomainLink:"Bind Account",
        bindFailed : "Failed to bind the account.",
        bindRepeat : "Your account has already been bound to another partner. You cannot bind the account to more than one partner.",
        "createDomain.remindCompleteInfo" : "Complete the following information to create and bind a HUAWEI CLOUD account. Already have an account?",
        "bindDomain.remindCompleteInfo" : "Enter your HUAWEI CLOUD account information to bind to this account. Do not have an account yet?",
        "createSubUserInfo" : "Complete the following information to create and bind a HUAWEI CLOUD subuser account.",
        enterpriseUser: "IAM User Login",
        enterpriseUserLogin: "IAM User Login",
        personageUser: "Account Login",
        enterpriseUser4Intl: "IAM User Login (International)",
        personageUser4Intl: "Account Login (International)",
        accountPlaceHolder: "Account name",
        HongKongAccountPlaceHolder: "Account name",
        domainPlaceHolder: "Agent ID/name",
        roleNamePlaceHolder: "Agent name",
        failedToswitchRole: "Agent switchover failed.",
        switchSubmit: "Switch Role",
        agencyDesc: "A user ID and password can be used to manage resources of multiple accounts. After the HUAWEI CLOUD administrator assigns roles to you, you can switch between roles.",
        userNamePlaceHolder: "IAM user name, email, or mobile number",
        HongKongUserNamePlaceHolder: "IAM user name or email address",
        accountNamePlaceHolder: "Account name, email, or mobile number",
        HongKongAccountNamePlaceHolder: "Account name or email",
        accountTip: "Account",
        passwdPlaceHolder: "Password",
        iamPasswdPlaceHolder: "IAM user password",
        verifyCodePlaceHolder: "CAPTCHA code",
        "GraphicsVerifyCodeLabel": "CAPTCHA Code:",    
        GraphicsVerifyCode: "Security check",
        InputGrapVerifyCodeInfo: "For security purposes, please enter the characters displayed on the following image.",
        GrapVerifyCodeFailed: "The CAPTCHA code is incorrect or has expired. Enter the correct code.",
        "getVerifyCode": "Refresh the image.",
        loginSubmit: "Log In",
        logining: "Logging in...",
        mobileNumberLogin: "Mobile number",
        noMobileLogin: "Account name or email",
        userNameMobliePH: "Mobile number",

        rememberName: " Remember me",
        rememberLogin: " Remember me",
        rememberName4Intl: " Remember me",
        forgetPwd: "Forgot Password",
        emaiNamePwd: "Incorrect email address.",
        phoneNamePwd: "Incorrect mobile number.",
        domainNamePwd: "Incorrect account name.",
        wrongNamePwd: "Incorrect password.",
        wrongNamePwd4Intl: "Incorrect username or email address.",

        learnMore: "Learn more",
        iamAccountTip: "The account used to create an IAM user in IAM. ",
        iamUsernameTip: "An IAM user created using the account in IAM. ",
        iamAccountTipHelp: "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section0",
        iamUsernameTipHelp: "/en-us/productdesc-iam/iam_01_0023.html?utm_campaign=ua&utm_content=iam&utm_term=login#section1",

        wrongIPBlacklist: "The device you are using for login is insecure. Use another device.",
        wrongIPFrequencyLimiting: "The maximum number of unsuccessful login attempts allowed from the same IP address has been reached. Try again later.",
        wrongEquipmentIDFrequencyLimiting: "The maximum number of unsuccessful login attempts allowed from the same device has been reached. Try again later or use another device.",
        MachineOperation: "The device you are using for login is insecure. Use another device.",

        emaiNamePwdChances: "Incorrect email address. You will need to log in again if {0} more attempts are unsuccessful.",
        phoneNamePwdChances: "Incorrect mobile number. You will need to log in again if {0} more attempts are unsuccessful.",
        domainNamePwdChances: "Incorrect account name. You will need to log in again if {0} more attempts are unsuccessful.",
        wrongNamePwdChances: "Incorrect password. You will need to log in again if {0} more attempts are unsuccessful.",
        wrongNamePwdFourChances: "Incorrect authentication information. 4 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdThreeChances: "Incorrect authentication information. 3 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdTwoChances: "Incorrect authentication information. 2 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdoneChances: "Incorrect authentication information. 1 more unsuccessful attempt will disable login for 15 minutes.",
        wrongNamePwdFourChances4Intl: "Incorrect password. 4 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdThreeChances4Intl: "Incorrect password. 3 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdTwoChances4Intl: "Incorrect password. 2 more unsuccessful attempts will disable login for 15 minutes.",
        wrongNamePwdoneChances4Intl: "Incorrect password. 1 more unsuccessful attempt will disable login for 15 minutes.",

        userAccountsLocked: "You have entered incorrect username or password 5 times. The IP address you are using for login will be locked for 15 minutes.",
        userAccountsStopped: "Your account has been disabled. Please contact the administrator.",
        domainAccountsStopped: "Your account has been disabled.",
        clientIpInvalid: "You are not allowed to log in from this device due to the access control rules set by the administrator. ",
        userNotExist: "The user does not exist. Contact the administrator. ",
        "clientIpInvalid.learnMore": "Learn more",
        "clientIpInvalid.helpUrl": "/en-us/usermanual-iam/iam_07_0003.html",
        notAllowFpwd: "You are not allowed to reset the password using this device.",
        warning: "Warning",
        "systemException": "The system is busy. Refresh the page and try again.",
        freqLocked: "You have tried too many times within a short period. Please try again later.",
        wrongVerifyCode: "The verification code is incorrect or has expired.",
        invalidInput: "Invalid parameter value.",
        serviceUrlInvalid: "Login failed. <a href='/'>Try again</a>. ",
        maxSessionLimit: "The maximum number of online user sessions has been reached.",
        "multiUserInvalid": "You have already logged in from this device. Refresh the page or log out if you want to use another account to log back in.",
        "pageTimeout": "The operation timed out. Refresh the page and try again.",
        "accountClosed": "The account is being closed.",
        invalidInputFourChances: "Incorrect parameter. 4 more unsuccessful attempts will disable login for 15 minutes.",
        invalidInputThreeChances: "Incorrect parameter. 3 more unsuccessful attempts will disable login for 15 minutes.",
        invalidInputTwoChances: "Incorrect parameter. 2 more unsuccessful attempts will disable login for 15 minutes.",
        invalidInputoneChances: "Incorrect parameter. 1 more unsuccessful attempt will disable login for 15 minutes.",
        loginReactivateFail: "Failed to send the activation email. Please try again.",
        pwdSame: "The new password must be different from the old password.",
        initialPwdSame : "The new password must be different from the initial password.",
        historyPwdSame: "The new password must be different from historical passwords.",
        copyrightNotice1: "© {0}, Copyright by HUAWEI CLOUD. All rights reserved. ",
        copyrightNotice1_hk: "© {0}, Huawei Services (Hong Kong) Co., Limited or its affiliates. All rights reserved.",
        copyrightNotice2: "All rights reserved.",
        copyrightNotice3: "Jiangsu ICP Registration Number: 17040376-32",
        copyrightNotice4: "Jiangsu B2-20130048",
        copyrightNotice5: "Jiangsu Public Security Website Registration Number: 32011402010636",
        "legalNotice": "Legal Notice",
        "legalStatement": "Legal Notice",
        "siteTerms": "Site Terms",
        "privacyProtect": "Privacy Statement",
        "privacyStrategyStatement": "Privacy Statement",
        "reportAbuse": "Report Abuse",
        "sa_nisr": "Acceptable Use Policy",
        "sa_nisr_intl": "Acceptable Use Policy",
        "sa_cua": "HUAWEI CLOUD Customer Agreement",
        "sa_cua_intl": "HUAWEI CLOUD Customer Agreement",
        "enterpriseSwitchTip": "This login mode is for logging in with usernames assigned by an enterprise administrator.",
        "personalSwitchTip": "This login mode is for logging in with account names created during account registration.",
        "usingOtherWaysLogin": "Use Another Account",
        "otherWaysLogin": "Log In Using Another Account",
        "HWSdeveloper": "Huawei Developer Alliance",
        "hwportal": "Huawei Official Website",
        "HWICTdeveloper": "Huawei ICT Developer",
        "WeLink": "WeLink",
        readAgree: "I have read and agreed to the ",
        hwCloudAgreement: "HUAWEI CLOUD Customer Agreement",
        secretprotect : "Privacy Statement",
        hwCloudAgreementMobile: "HUAWEI CLOUD Customer Agreement",
        secretprotectMobile : " Privacy Statement",
        companyUserRegistration: "Register Enterprise User",
        personalUserRegistration: "Register User",
        companyAccountName: "Username:",
        userName: "Username: ",
        registerMail: "Email Address:",
        congratulationsSucceed: "Registration successful.",
        password: "Password:",
        registerMailStep3:"Email:",
        passwordPlaceHolder: "Enter the password.",
        confirmPassword: "Confirm Password: ",
        confirmPasswordPlaceHolder: "Enter the password again.",
        companyName: "Enterprise:",
        contact: "Contact:",
        phoneNum: "Mobile Number: ",
        phonePlaceHolder: "Enter your mobile number.",
        msgCode: "Verification Code: ",
        msgCodeTxt: "Send Code",
        msgPHTxt:"Verification code",
        msgCodeTxtWait: "Resend Code ({0}s)",
        msgCodeWrong: "The verification code is incorrect.",
        region: "Region: ",
        "register.submit": "Register",
        "register.finish": "Finish",
        submit: "Next",
        innerKeyWord: "The name cannot start with a system keyword.",
        accountNamePH: "Enter your username.",
        emailPH: "Enter your email address.",
        companyNamePH: "Enter the name of your enterprise.",
        mobileCompanyName:"(Optional) Enter the name of your enterprise.",
        "registerSuccess": "Registration successful.",
        "pleaseCompleteInfo": "For security purposes, please provide information about your enterprise.",
        "complete": "Complete the",
        "companyInfo": "enterprise profile",
        "rejectAndBack": "Go back to the",
        "homePage": "homepage",
        "period": ".",
        "goTo": " Go to",
        "myCredential": "My Credentials",
        "completeUserInfo": "to complete personal information.",
        "fpwd.findPasswd": "Reset Password",
        "fpwd.enterpriseName": "Account Name:",
        "fpwd.accountName": "Email Address or Mobile Number:",
        "fpwd.SMSVerifyCode": "Enter the verification code.",
        "fpwd.emailVerifyCode": "Enter the verification code.",
        "fpwd.getCode": "Send Code",
        "fpwd.confirmAccount": "Verify Identity",
        "fpwd.resetPwd": "Reset Password",
        "fpwd.resetSuccess": "Finish",
        "fpwd.findSuccess": "Password reset successfully.",
        "fpwd.newPasswd": "New Password:",
        "fpwd.confirmPasswd": "Confirm Password:",
        "fpwd.enterpriseNamePH": "Enter the account name.",
        "fpwd.accountNamePH": "Enter an email address or mobile number.",
        "fpwd.verifyCodePH": "Verification code",
        "fpwd.confirmPasswdPH": "Enter the new password again.",
        "fpwd.newPasswdPH": "Enter a new password.",
        "fpwd.newPasswdPHApp": "New Password",
        "fpwd.nextStepBtn": "Next",
        "fpwd.backTo": "Back",


        "fpwd.titleDetail": "Enter your account information.",
        "fpwd.titleIAMDetail": "Enter your IAM user information.",
        "fpwd.multiUsersTip": "The mobile number is bound to multiple accounts. Select the account for which you want to reset the password.",
        "fpwd.accountConfirm": "Account Verification",
        "fpwd.personalAccount": "Account",
        "fpwd.IAMAccount": "IAM User",
        "fpwd.typePersonalTip": "The account created when you registered with HUAWEI CLOUD using a mobile number.",
        "fpwd.typeIAMTip": "The user created using an account in IAM.",
        "fpwd.accountOrEmailPH": "Account name or email",
        "fpwd.IAMAccountNamePH": "IAM user name, email, or mobile number",
        "fpwd.IAMAccountNamePHNew": "IAM user name or email",
        "fpwd.identityVerification": "Identity Verification",
        "fpwd.identityVerificationDec": "Select an identity verification method.",
        "fpwd.passwordReset": "Reset Password",
        "fpwd.passwordResetDesc": "Set a new password.",
        "fpwd.step1.fpwdByPhone": "Mobile Number Verification",
        "fpwd.step1.fpwdByemail": "Account/Email Verification",
        "fpwd.step1.phoneAccountNamePH": "Mobile number",
        "fpwd.step2.verificationCodePH": "Verification code",
        "fpwd.step2.sendVerificationCode": "Send Code",
        "fpwd.step2.unbindDesc": "Your identity cannot be verified because the account you are using has not been bound with any email address or mobile number.",
        "fpwd.step2.unbindIAMDesc": "Your identity cannot be verified because the IAM user account you are using has not been bound with any email address or mobile number.",
        "fpwd.step2.exceptionService": "If your mobile number or email address is unavailable, request the administrator to reset your password.",
        "fpwd.step2.sendEmailCode": "Email address ({0})",
        "fpwd.step2.sendMobileCode": "Mobile number ({0})",
        "fpwd.step2.unabledMethod": "Contact customer service",
        "fpwd.step2.helpMsg": "Customer Service",
        "fpwd.step2.helpTel1": "Chinese mainland: +86 4000-955-988",
        "fpwd.step2.helpTel2": "Hong Kong SAR, China: +852 800-931-122",
        "fpwd.retrieveTxt": "Resend Code ({0}s)",
        "fpwd.step3.showPwdTip": "Show",
        "fpwd.step3.hidePwdTip": "Hide",
        "fpwd.goToLogin": "Log In",
        "fpwd.successTxt": "Password reset successfully",
        "fpwd.loginCountdownTxt": "You will be automatically redirected to the login page in {0}s.",


        "domainuserAccountsLocked": "Your account is pending activation. Click the link in the registration email to activate your account.",
        "fpwd.sendCodeFailed": "Failed to send the verification code because the system is busy.",
        "fpwd.getCodeFail": "You have already obtained the verification code 5 times. Please try again tomorrow.",
        "wrong_sendCodeFailed": "Failed to send the verification code. Click Send Code to obtain another one.",
        "fpwd.invalidVerifyCode": "The verification code is incorrect. Please try again.",
        "fpwd.setPasswdFailed": "Failed to set the password. Please try again.",
        "fpwd.ipLocked": "The IP address has been locked.",
        "fpwd.MultipleIAMUserNameByMobile": "The mobile number is bound to multiple IAM users. Reset the password by using your email.",
        "fpwd.MultipleAccountNameByMobile": "The mobile number is bound to multiple accounts. Enter an account name to continue.",
        "fpwd.MultipleAccountNameByMobileError": "The mobile number is bound to multiple accounts. Reset the password by using this mobile number on a computer or using your email.",
        "fpwd.MultipleAccountsByMobileReminder": "The account name must be specified if the mobile number is bound to multiple accounts.",
        "fpwd.EnterCorrectEnterpriseAccount": "Enter the name of an account that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectMobile": "Enter a mobile number that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectEnterpriseAccountAndMobile": "Enter an account name or mobile number that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectEmail": "Enter an email address that has been registered with HUAWEI CLOUD.",
        "fpwd.EnterCorrectEnterpriseAccountAndEmail": "Enter the correct account name or email address.",
        "fpwd.EnterCorrectEnterpriseVerificationCode": "Enter the correct CAPTCHA code.",
        "operationTooFrequent": "You have tried too many times within a short period. Please try again later.",

        "fpwd.contactService": "If you do not have access to your mobile phone and email, contact customer service at {0} for assistance.", //4000-955-988, +7 (495) 800 1 800
        "fpwd.contactHKService": "If you do not have access to your email, contact customer service at {0} for assistance.",
        "fpwd.ErrorRegionAccount": "Enter a valid HUAWEI CLOUD account.",
        "countryCodeSelect": "Select a country code.",
        bindPhone: "Mobile Number:",
        bindPhoneNum: "Mobile Number:",
        "alreadyHaveAccount": "",
        "login": "Log In",
        "loginNow": "Log In",
        safetyDegree: "Password Strength:",
        handsRegisterInfo: "To use Huawei PDA Cloud Service, ",
        hansRegistration: "register now.",
        filloutRegisterInfo: "Set Registration Info",
        checkAccountInfo: "Complete Account Info",
        registerSucceed: "Finish",
        successAccoutInfo: "Your account information: ",
        descriptionInfo: "You can log in using the account name, mobile number, or email address.",
        linkFailed: "The link has expired.",
        linkFailedDetail: "Your account has already been activated or the activation link has expired.",
        linkFailedHelp: "",
        linkFailedLogin: "Log in",
        serverTimeout: "The server timed out. Please try again later.",
        mainMsg: "The activation email has been sent to: ",
        secondMsg: "Click the link in the email and complete the activation within 24 hours.",
        checkEmail: "Open Email",
        didNotGetEmail: "Didn't receive the email?",
        checkSpamMail: "1. Check your junk folder.",
        stillDidNotGetEmail: "2. If you haven't got the email, ",
        resendEmail: "send the email again.",
        alwaysDidNotGetEmail: "3. If you still haven't got the email, ",
        changeMailbox: "enter another email address.",
        replaceEmailTip: "You can change your email address only once in 24 hours. Ensure that you enter the correct email address.",
        sendNewEmail: "Send",
        alreadySend: "The activation email has been sent.",
        sendFailed: "Failed to send the email.",
        inputEmail: "Enter your email address.",
        "email": "Email:",
        countToHomepage: "You will be automatically redirected to the login page in {0} seconds.",
        "registerFailed.emailRepeat": "An account associated with the same email address already exists.",
        "registerFailed.nameRepeat": "An account associated with the same name already exists.",
        "registerFailed.mobileRepeat": "An account associated with the same mobile number already exists.",
        "registerFailed.nameCannotBegin": "The name cannot start with a digit or an underscore (_).",
        "registerFailed.nameCannotContain": "Only letters, digits, hyphens (-), and underscores (_) are allowed.",
        "registerSuccess.backToHomepage": "1. ",
        "registerSuccess.returnHomepage":"Back",
        "registerSuccess.backToHomepageLink": "Go back to the HUAWEI CLOUD homepage.",
        "registerSuccess.backToHomepageLinkP1": "Go back to",
        "registerSuccess.backToHomepageLinkP2": "the HUAWEI CLOUD homepage.",
        "registerSuccess.second": "2.",
        "registerSuccess.goToBss": "Visit ",
        "registerSuccess.goToBssFillInfo": " and complete the registration information. You will receive updates about discounts and promotions as and when they become available.",
        "registerSuccess.bssAccountInfo": "User Center",
        "registerSuccess.redirecting": "Redirecting...",
        "registerSuccess.redirecting.back": "You will be automatically redirected to the initial page in {0} seconds.",
        "registerSuccess.autoClose": "You will be automatically redirected to the initial page in {0} seconds.",
        "registerSuccess.browserPreventClose": "Your browser configuration does not allow the system to automatically close pages.",
        "registerSuccess.homepage": "Home",
        "registerSuccess.userCenter": "User Center",
        "registerSuccess.consoleHome": "Management Console",
        "registerSuccess.helpCenter": "Help",

        "resetPwd.title": "First Login",
        "resetPwd.titleDetail": "For security purposes, please change the password.",
        "resetPwd.phone": "Mobile Number:",
        "resetPwd.mailbox": "Email Address:",
        "resetPwd.byPhone": "Mobile Number Verification",
        "resetPwd.byMailbox": "Email Address Verification",
        "resetPwd.smsMsgCode": "Verification Code: ",
        "resetPwd.emailMsgCode": "Verification Code:",
        "resetPwd.getSmsMsgCode": "Send Code",
        "resetPwd.getEmailMsgCode": "Send Code",
        "resetPwd.retrieveMsgCode": "Resend Code ({0}s)",
        "resetPwd.resetFailed": "Failed to change the password.",
        "resetPwd.oldPasswd": "Old Password:",
        "resetPwd.newPasswd": "New Password:",
        "resetPwd.apiKeyTitle": "Change API Password",
        "resetPwd.apiKeyDetail": "For security purposes, please change the API password.",
        "resetPwd.apkKey": "Old API Password:",
        "resetPwd.confirmNewPasswd": "Confirm Password:",
        "resetPwd.resetPwdFailed": "The old password is incorrect. Enter the correct password.",
        "resetPwd.resetCount": "The old password is incorrect. You will need to log in again if {0} more attempts are unsuccessful.",
        "resetPwd.getCodeFail": "You have already obtained the verification code 5 times. Please try again 15 minutes later.",
        "resetPwd.InitPasswd": "Initial Password:",
        "resetPwd.InitPasswdError":"The initial password is incorrect. Enter the correct password.",
        "resetPwd.InitPasswdCount":"The initial password is incorrect. You will need to log in again if {0} more attempts are unsuccessful.",
        "modifyPwdIntervalTimeLessThanMinValidTime": "Change the password only when the minimum password age has been reached. Click Cancel to cancel the change password operation and log in.",
        "pwdModifyTitle": "Change Password",
        "pwdExpiredTitle": "Password Expired",
        "pwdExpiringDesc": "Your password will expire in {0} days. Please change it at the earliest.",
        "pwdExpiredDesc": "Your password has expired. Please set a new password.",
        "noRight": "Insufficient permissions. Please contact the administrator.",

        "browserSupport": "HUAWEI CLOUD works best with the following browsers:",
        "browserSupport.chrome": "Google Chrome",
        "browserSupport.chromeVersion": "(36.0 or later)",
        "browserSupport.firefox": "Mozilla Firefox",
        "browserSupport.firefoxVersion": "(35.0 or later)",
        "browserSupport.ie": "Internet Explorer",
        "browserSupport.ieVersion": "(9.0 or later)",

        "reactivate.reactivateAccount": "Activate Account",
        "reactivate.pleaseCheckEmail": "Your account is pending activation. Log in to your registered email address and click the link in the registration email to activate your account.",
        "advertisement.txt": "Free for the first 100 trials",
        "advertisement.buttonTxt": "Apply",

        "fphone.changePhoneNum": "Change Mobile Number",
        "fphone.changeSuccess": "Finish",
        "fphone.registerEmail": "Email Address:",
        "fphone.registerEmailPH": "Enter your email address.",
        "fphone.emailVerifyCode": "Email Verification Code:",
        "fphone.getVerifyCodeByEmail": "Send Code",
        "fphone.emailVerifyCodePH": "Enter the verification code.",
        "fphone.newPhoneNum": "New Mobile Number:",
        "fphone.newPhoneNumPH": "Enter a new mobile number.",
        "fphone.smsVerifyCode": "SMS Verification Code:",
        "fphone.getVerifyCodeBySms": "Send Code",
        "fphone.smsVerifyCodePH": "Enter the verification code.",
        "fphone.changePhoneSuccess": "The mobile number has been changed successfully.",
        "fphone.newPhoneNumInfo": "New Mobile Number:",
        "fphone.phoneRepeat": "The mobile number has already been used.",
        "fphone.exceedMaxAccounts": "The maximum number of accounts (6) that can be bound to the mobile number has been reached. ",
        "mobileNumber": "Mobile Number:",
        "fphone.changeMobile": "Change Mobile Number",
        "sendSmsIntervalErr": "The maximum number of attempts to obtain the verification code has been reached. Please try again after 1 minute.",
        "cookie.chromeDesc":"Choose Settings > Show Advanced Settings > Privacy > Content Setting. Deselect \"Block third-party cookie and site data\", select \"Allow local data (recommended)\", and click Finish. Then, restart the browser and log in again.",
        "cookie.firefoxDesc" :"Choose Options > Privacy. Select Custom settings for history, deselect \"Always use private browsing mode\", select \"Accept a cookie from the sites\", and click OK. Then, restart the browser and log in again.",
        "cookie.ieDesc":"Choose Tools > Internet Options > Privacy. Set the setting for the Internet zone to \"Accept All Cookies\", click Apply, and click OK. Then, restart the browser and log in again.",
        "cookie.chromeName":"Google Chrome:",
        "cookie.firefoxName":"Mozilla Firefox:",
        "cookie.ieName":"Internet Explorer:",
        "cookie.title":"How Do I Enable Cookies on My Browser?",
        "cookie.loginTip":"You can log in only if cookies are enabled. ",
        "cookie.startCookie":"Learn more",
        "verifyCode.intervalError": "The maximum number of attempts to obtain the verification code has been reached. Please try again after 1 minute.",
        "verifyCode.invalid": "The verification code has expired. Click Send Code to obtain another one.",
        "verifyCode.error": "The verification code is incorrect. Enter the correct verification code.",
        "verifyCode.locked": "The verification code function has been locked. Please try again tomorrow.",
        "verifyCode.locked.custom" : "The verification code function has been locked. Please try again {0} minutes later or contact custom service at 4000-955-988.",
        "verifyCode.sendFailed": "Failed to send the verification code. Click Send Code to obtain another one.",
        "verifyCode.remainderCount": "You have {0} verification attempts remaining. If the remaining attempts are unsuccessful, you will need to wait for some time before you can send a code again.",
        "verifyCode.cantAcquire": "The verification code function has been locked. Please enter the most recent verification code you obtained.",
        "verifyCode.emailInvalidAndSMSError": "The SMS verification code is incorrect. Try again with a valid email verification code.",
        "verifyCode.email.invalid": "The verification code has expired. Click Send Code to obtain another one.",
        "verifyCode.email.error": "The verification code is incorrect. Enter the correct verification code.",
        "verifyCode.sms.invalid": "The verification code has expired. Click Send Code to obtain another one.",
        "verifyCode.sms.error": "The verification code is incorrect. Enter the correct verification code.",
        "verifyCode.usernameRepeat": "The username has already been used. Enter another username.",
        "verifyCode.maxmiumSubUserNum": "The number of users has reached the maximum limit allowed.",
        "verifyCode.emailExist": "The email address has already been used. Enter another email address.",

        "loginVerification": "Login Verification",
        "loginVerification.tips": "If you do not want the custom information to be displayed during login, contact the administrator.",
        "titles.loginVerification": "HUAWEI CLOUD - Login Verification",
        "loginVerification.presetLoginInfo": "Preset Custom Information",
        "loginVerification.warningInfo": "If the displayed information is not your preset custom information, cancel the login.",
        "loginVerification.checkBySMS": "SMS",
        "loginVerification.SMSHasSentTo": " (The verification code will be sent to your mobile phone.)",
        "loginVerification.pleaseClickAgain": " (If the verification code is not received within 60s, click Send Code again.)",
        "loginVerification.userLoginInfo": "Login Information",
        "loginVerification.lastSuccessTime": "Last Successful Login",
        "loginVerification.lastFailedTime": "Last Unsuccessful Login",
        "loginVerification.failedTimes": "Unsuccessful Login Attempts",
        "loginVerification.lockInfo": "Your account will be locked for {1} minutes if {0} more consecutive login attempts are unsuccessful.",

        "loginVerification.MFATitle": "Virtual MFA device",
        "loginVerification.MFAContext": "Enter the 6-digit code generated on the authenticator app.", 
        "loginVerification.MFAHelp": "Learn how to get MFA verification codes.",
        "loginVerification.MFALabel": "Verification Code",
        "loginVerification.MFANotUseTip": "Virtual MFA Device Unavailable?",
        "loginVerification.MFANotUseMessage1": "Contact your administrator to remove the virtual MFA device.",
        "loginVerification.MFANotUseMessage2": "Contact HUAWEI CLOUD customer service.",
        "loginVerification.resetMFAHelpUrl": "<a href='{0}' target='_blank' rel='noopener noreferrer'>Learn how</a> to unbind or remove a virtual MFA device.",
        "loginVerification.rememberMFALabel": "Remember me for 7 days",
        "loginVerification.rememberMFALabel.disabledTip": "Limited to 5 IAM users per browser. ",

        "loginVerification.emailCheckTitle": "Email",
        "loginVerification.emailCheckContent": " (A verification code will be sent to {0}.)",
        "loginVerification.emailCodeLabel": "Verification Code",
        "loginVerification.emailCodeTxt": "Send Code",

        "loginVerification.verificationType": "Verification Method",
        "loginVerification.verificationTypeForPhone": "绑定手机号与验证方式",
        "loginVerification.verificationTypeForEmail": "绑定邮件地址与验证方式",
        "loginVerification.bindPhone": "Mobile Number",
        "loginVerification.bindPhoneTips": "The administrator has enabled SMS-based authentication. Enter a mobile number.",
        "loginVerification.bindPhonePH": "Enter a mobile number.",
        "loginVerification.bindEmail": "Email Address",
        "loginVerification.bindEmailTips": "The administrator has enabled email-based authentication. Enter an email address.",
        "loginVerification.bindEmailPH": "Enter an email address.",
        "loginVerification.verifyCode": "Verification Code",
        "loginVerification.verifyCodeBtnTxt": "Send Code",
        "loginVerification.verifyCodePH": "6-digit code",
        "loginVerification.verifyCodeEmailPH": "6-digit code",
        "loginVerification.sendCodeTxt": "The verification code has been sent. To ensure your account security, do not share this code with anyone.",
        "loginVerification.sendCodeFailed": "Failed to send the verification code because the system is busy.",
        "loginVerification.validEmailOrPhone": "The email address or mobile number is unavailable.",
        "loginVerification.retrieveTxt": "Resend Code ({0}s)",
        "loginVerification.otherAccount": "Use Another Account",
        "loginVerification.goOnLogin": "OK",
        "loginVerification.title": "Bind Virtual MFA Device",
        "loginVerification.firstStep": "Step 1: Scan the following QR code to install the HUAWEI CLOUD app, or install another authenticator app.",
        "loginVerification.firstStepIntroduction": "The authenticator app will prompt you to add your account.",
        "loginVerification.secondStep": "Step 2: Set up the app.",
        "loginVerification.secondStepIntroduction": "Open the app, and scan the following QR code or enter the secret key.",
        "loginVerification.username": "Username",
        "loginVerification.domainname": "Account Name",
        "loginVerification.secretKey": "Secret Key",
        "loginVerification.thirdStep": "Step 3: Enter the MFA verification codes.",
        "loginVerification.thirdStepIntroduction": "Enter two consecutive MFA verification codes generated on the app.",
        "loginVerification.firstRegCode": "Verification Code 1",
        "loginVerification.secondRegCode": "Verification Code 2",
        "loginVerification.submitText": "OK",
        "loginVerification.bindMFASucceed": "Virtual MFA device bound successfully.",
        "loginVerification.mfaCodeError": "Incorrect MFA verification code. Enter the correct code.",
        "loginVerification.mfaCodeLocked": "You have exceeded the maximum verification code requests allowed. Please try again after 5 minutes.",

        "bindAccount.title": "Bind HUAWEI CLOUD Account",
        "bindAccount.submit": "Register and Bind",
        "registerGiftSuffixMobile": "Claim Cash Coupons",
        "bindAccount.remindCompleteInfo": "Complete the following information to register a HUAWEI CLOUD account and bind it.",
        "bindAccount.bindSuccess": "Account registered and bound successfully.",
        "bindAccount.HWSAccount": "Your HUAWEI CLOUD account:",
        "bindAccount.timeRemind": "After {0} seconds",
        "bindAccount.redirectPage": "Back to the initial page",
        "validCountryCode": "Select a country code.",
        "registerGift":"You can claim cash coupons after successful registration.",
        "registerGiftAddress": "Claim Cash Coupons",
        "registerSuccess.goToGift": "Go to ",
        "registerSuccess.goToGiftFillInfo": " to claim special cash coupons for new users.",
        "usercompanyAccount":"Your account information is as follows:",
        "welcomeLogin.titleDetail":"For security purposes, set a password.",
        "welcomeEmail.title":"Welcome Email",
        "welcomeEmail.linkTimeout": "The link has expired.",
        "welcomeEmail.linkExpired":"The link is unavailable.",
        "welcomeEmail.resendEmail":"Send another welcome email again.",
        "welcomeEmail.contactAdm":"Contact the administrator to send another welcome email again.",
        "welcomeEmail.alreadySend":"The welcome email has been sent.",
        "titles.setPassword":"HUAWEI CLOUD - Set Password",
        "titles.welcomeEmail":"HUAWEI CLOUD - Welcome Email",
        "welcomeEmail.setPassword":"Set Password",
        "dateFormate":"MMM dd, yyyy HH:mm:ss",
        "sessionExpired":"Your session has expired. Log in again.",
        "m.userNamePlaceHolder":"Username, email, or mobile number",
        "m.HongKongUserNamePlaceHolder":"Username or email",
        "m.accountNamePlaceHolder": "Account name or email",
        "m.HongKongAccountNamePlaceHolder": "Account name or email",
        "m.verifyCodePlaceHolder":"CAPTCHA code",
        "inValidCountryCode" : "Select a country code.",
        "mobile.CountryCode":"+86 (Chinese mainland)",
        "authenticationInfo": "Some functions will be unavailable to users who have not completed real-name authentication.",
        "authenticationForwardInfo": "Complete real-name authentication for a complete service experience.",
        "authenticationForward": "real-name authentication",
        "registerSuccess.goToAuthentication":"Complete",
        "registerSuccess.authenticationInfo":"to get a 6-month free trial package.",
        "fpwd.findByEmail": "Email Address Verification",
        "fpwd.findByPhone": "Mobile Number Verification",
        "fpwd.accountNameByEmail": "Email Address:",
        "fpwd.accountNameByPhone": "Mobile Number:",
        "fpwd.phoneAccountNamePH" : "Enter a mobile number.",
        "eChannelName": "Huawei Enterprise Partner",
        "uniportalName": "Huawei Account",
        "moreLink":"More",
        "registerSuccess.authenticationForward": "Complete Real-Name Authentication",
        "homepageLink": "Home",
        "helpCenter": "Documentation",
        "cloudCommunity": "Cloud Community",
        "registerSuccess.goToUserZone": "Go to ",
        "registerSuccess.userZoneLink": "New User Zone",
        "registerSuccess.userZoneInfo": " to get your special 50% off package.",
        "register.accountPlaceHolder": "Account name",
        "register.passwordPlaceHolder": "Password",
        "register.confirmPasswordPlaceHolder": "Confirm password",
        "register.phonePlaceHolder": "Mobile number",
        "register.msgCodePlaceHolder": "Verification code",
        "register.accountNameLength": "Enter 5 to 32 characters.",
        "register.bindACccountPlaceHolder":"Account name, email, or mobile number",

        "remindBindEmail.title":"Bind Email Address",
        "remindBindEmail.remindMsg":"Your account does not have an email address bound to it. Bind an email address to:",
        "remindBindEmail.remindInfo1":"● Receive notifications when cloud resources are provisioned, deleted, or are about to expire.",
        "remindBindEmail.remindInfo2":"● Verify your identity when you perform important operations, such as changing your mobile number, resetting your password, and deleting ECSs.",
        "remindBindEmail.bind":"Bind Now",
        "remindBindEmail.nextBind":"Bind Later",
        "remindBindEmail.remind":"Information",
        "remindBindEmail.remindHideInfo":"Bind an email address on a new tab page.",
        "remindBindEmail.remindHideFailde":"If the binding fails, ",
        "remindBindEmail.remindHideFailde2":"bind another email address.",
        "remindBindEmail.remindHideSuccess":"Binding Completed",

        "notify.openPage": "Please wait...",
        "notify.closeSecondBefore": "Operation Successful.",
        "notify.closePage": "Operation successful. Please close the page",

        "registerFailed.accountNameRepeat": "An account with the same name already exists.",
        "register.bindAccountPlaceHolder":"Account name, email, or mobile number",

        
        "privacyPolicyUpdate": "Privacy Statement Updated",
        "privacyTipPre": "Dear customer, we have updated the HUAWEI CLOUD Privacy Statement. We understand the importance of your privacy and are fully committed to protecting it. Please read the updated",
        "privacyTipSuf": "carefully to learn how we protect your personal data.",
        "agreementBtnTxt": "Agree",
        "privacyAgreementNotAcceptedError": "Select the check box to confirm that you have read and accepted the HUAWEI CLOUD Privacy Statement.",

        "OIDC.errorDefault": "System error. Please contact the administrator.",
        "OIDC.errorO001": "System error. Please try again.",
        "OIDC.errorO002": "Invalid domain ID.",
        "OIDC.errorO003": "Invalid identity provider ID.",
        "OIDC.errorO004": "Invalid service URL.",
        "OIDC.errorO005": "Cannot find the OpenID Connect configuration.",
        "OIDC.errorO006": "Invaid OpenID configuration.",
        "OIDC.errorO007": "Invalid ID Token.",
        "OIDC.errorO008": "The State parameter is invalid.",
        "OIDC.errorO009": "Invalid JWT.",
        "OIDC.errorO010": "Acl check failed.",
        "OIDC.errorO011": "Failed to obtain the IAM token based on the mapping rules. Check the mapping rules or contact the administrator.",
        "OIDC.errorO012": "No reachable project to log in.",
        "OIDC.errorO013": "Too many requests. Please try again later.",
        "OIDC.errorO014": "Cannot access the console in the [program] access mode.",
        "OIDC.errorO015": "Invalid error.",
        "console_term_500Error_label":"The system is busy. Please try again later.",
        "console_term_404Error_label":"Sorry! Failed to find the page.",
        "console_term_401Error_label":"Sorry! The page has expired.",
        "titles.loginReminder": "HUAWEI CLOUD – Login",

        //扫码登录需求相关词条
        "QRLogin.title1": "QR Login",
        "QRLogin.title2": "Log in to Huawei Cloud",
        "QRLogin.countDownTipPre1": "Please use the ",
        "QRLogin.countDownTipPre2": "HUAWEI CLOUD APP",
        "QRLogin.countDownTipPre3": " to scan the QR code to log in ",
        "QRLogin.remainingTime": "{0} seconds",
        "QRLogin.countDownTipSuffix": "QR code expires after ",
        "QRLogin.QRCodeInvalid": "QR code has expired",
        "QRLogin.refresh": "refresh",
        "QRLogin.scanSuc": "Scan Successfully",
        "QRLogin.scanSucTip": "Please follow the prompts to confirm login on your phone",
        "QRLogin.loginFail": "Login Failed",
        "QRLogin.loginFailTipPre": "Please click ",
        "QRLogin.loginFailTipSuffix": " and re-scan the QR code to log in",
        "QRLogin.downloadApp": "Download HUAWEI CLOUD App",
        "QRLogin.comma":", ",
        "QRLogin.loginReminder": "Login Reminder",
        "QRLogin.accountLogin": "Password Login",

        //统一ID相关
        "hwId.cookieMsg": "We use cookies to improve your browsing experience. By continuing to browse our site, you accept our cookie policy. ",
        "hwId.hwAccount": "HUAWEI ID",
        "hwId.privacyContent": "Your account and network information will be used to help improve your login experience. ",
        "hwId.hwportal": "Huawei Website Account",
        "hwId.eChannel": "Huawei Enterprise Partner",
        "hwId.casLogin.systemError": "Error",
        "hwId.casLogin.systemErrorDesc": "A system error occurred. Please refresh the page or contact customer service at +86 4000 955 988 (Chinese mainland) or +852 800 931 122 (Hong Kong, China).",
        "hwId.casLogin.accountError": "Error",
        "hwId.casLogin.accountErrorDesc": "Your account cannot be used to log in to HUAWEI CLOUD. Log in with another account.",
        "hwId.casLogin.accountErrorLink": "Learn more",
        "hwId.casLogin.accountErrorUrl": "/en-us/iam_faq/iam_01_0006.html",
        "hwId.casLogin.loginError": "Error",
        "hwId.casLogin.loginErrorDesc": "You cannot use your account to log in to HUAWEI CLOUD in this mode. Click HUAWEI ID Login and log in.",
        "hwId.casLogin.accountExternalErrorDesc": "Your current account is registered in [Europe or Russia]. HUAWEI CLOUD does not support accounts in the above regions for the time being. Please log in with accounts in other regions.",
        "hwId.casLogin.accountExternalErrorLink": "Learn more",
        "hwId.casLogin.accountTurkeyErrorLink": "Your current account is registered in [Turkey]. HUAWEI CLOUD does not support accounts in Turkey. Please <a href='{0}' target='_blank' rel='noopener noreferrer'>register for a HUAWEI CLOUD account</a> immediately, or log in with accounts in other region.",
        "hwId.casLogin.inactivatedError": "Inactive Account",
        "hwId.casLogin.inactivatedErrorDesc": "Your account has not been activated. The system has automatically sent an activation email to your registered email address. Please go to and click the link in the email address to complete the activation within 24 hours.",
        "hwId.casLogin.inactivatedErrorDesc.noEmail": "Your account has not been activated and does not have an email address. Huawei Cloud services are temporarily unavailable. Please change to another account and log in again.",
        "hwId.casLogin.inactivatedHwidError": "Inactive HUAWEI CLOUD Services",
        "hwId.casLogin.inactivatedHwidErrorDesc": "Your HUAWEI CLOUD business has not been activated, and the system has automatically sent an activation email to your registered email address. Please go to and click the link in the email address to complete the activation within 24 hours.",
        "hwId.casLogin.inactivatedHwidErrorDesc.noEmail": "Your HUAWEI CLOUD business has not been activated and you do not have an email address. You cannot use HUAWEI CLOUD services temporarily. Please change to another account and log in again.",
        "hwId.casLogin.accessErrorDesc": "HUAWEI CLOUD does not have the authority to obtain the information of your current account. This account login is not supported temporarily. Please log in with another account.",
        "hwId.refresh": "Refresh",
        "hwId.cookies": "Cookies",
        "hwId.otherAccount": "Use Another Account:",
        "hwId.otherAccount.h5": "Use Another Account",
        "hwId.hwIdLogin": "Huawei Account Login",
        "hwId.accountPlaceHolder": "Tenant name or HUAWEI CLOUD account name",

        //统一ID找回密码页面改造
        "fpwd.accountFpwdTitle": "Reset HUAWEI CLOUD Account Password",
        "fpwd.iamFpwdTitle": "Reset IAM User Password",
        "fpwd.goAccountFpwd": "Reset HUAWEI CLOUD Account Password",
        "fpwd.goIAMFpwd": "Reset IAM User Password",
        "fpwd.step2.accountHelpMsg": "If you cannot perform verification using your mobile phone and email account, please call +86 4000 955 988 (Chinese mainland) or +852 800 931 122 (Hong Kong, China). If you have already retrieved your password, go to the login page and log in. ",
        "fpwd.step2.switchPhoneVerify": "Mobile Number Verification",
        "fpwd.step2.switchEmailVerify": "Email Address Verification",
        "fpwd.pwdValidateRule": "Password requirements:",
        "fpwd.pwdSafetyDegree": "Password strength:",
        "fpwd.selectUserTitle": "Select Account Name",
        "fpwd.step1.fpwdByEmail": "Tenant Name/Email Address Verification",
        "fpwd.step1.fpwdByPhone": "Mobile Number Verification",
        "fpwd.step1.phoneAccountNamePH": "Mobile number",
        "fpwd.verifyCodePlaceHolder": "CAPTCHA code",
        "fpwd.accountOrEmailPH": "Account name or email address",
        "fpwd.IAMAccountPH": "Name of the administrator account",
        "fpwd.IAMAccountNamePHNew": "IAM user name or email address",
        "fpwd.step2.sendVerificationCode": "Send Code",
        "fpwd.confirmPasswdPH": "Enter the new password again.",
        "fpwd.accountOrEmailPH.h5": "Account name or email address",
        "fpwd.step1.phoneAccountNamePH.h5": "Mobile number",
        "fpwd.IAMAccountPH.h5": "Name of the administrator account",
        "fpwd.IAMAccountNamePHNew.h5": "IAM user name or email address",
        "fpwd.verifyCodePlaceHolder.h5": "CAPTCHA code",
        "fpwd.newPasswdPH.h5": "Enter a new password.",
        "fpwd.confirmPasswdPH.h5": "Enter the new password again.",
        "fpwd.iamFpwdAccountError": "Please enter the correct IAM user name",
        //统一ID升级提示页面
        "hwId.upgradeTitle": "Upgrade to HUAWEI ID and Get Access to All Huawei Services",
        'hwId.upgradeDesc': 'You are logged in with a HUAWEI CLOUD account, which is just for HUAWEI CLOUD services. Upgrade your account to a HUAWEI ID to access the full range of Huawei services, including HUAWEI Developers, HUAWEI devices (such as HUAWEI Phones), Huawei Mobile Services (such as HUAWEI Mobile Cloud and HUAWEI Video). After upgrading, you\'ll be able to use your HUAWEI ID for all your HUAWEI CLOUD resources as well. ',
        'hwId.upgradeDescLink': 'Learn more',
        'hwId.upgradeAgreements.pre': 'I understand that HUAWEI ID collects my account name, mobile number, email address, registration country/region, and login credentials, and I have read and agree to',
        "hwId.upgradeAgreements.userAgreement": " HUAWEI ID User Agreement ",
        "hwId.upgradeAgreements.and": " and ",
        "hwId.upgradeAgreements.privacyPolicy": " Statement About HUAWEI ID and Privacy",
        "hwId.upgradeAgreements.period": ".",
        "hwId.upgradeBtnTxt": "Upgrade Now",
        "hwId.upgradeCancelBtnTxt": "Upgrade Later",
        "hwId.upgradePageTitle": "Account Upgrade - HUAWEI CLOUD",
        "hwId.upgradeGoBack": "Account Upgrade",
        "hwId.upgradeErrorTitle": "Failed to load",
        "hwId.upgradeErrorDesc": "Service error, please contact customer service",
        "hwId.upgradeErrorBtn": "OK",
        "hwId.forgetPwd": "Forgot Password",
        "hwId.hwCloudAccount": "HUAWEI CLOUD Account",
        "hwId.hwCloudAccountLogin": "Account Login",

        // 快捷登录
        "quickLogin.title": "Quick Login",
        "quickLogin.loginTip": "Log in through SMS or email verification.",
        "quickLogin.accountInputPH": "Mobile number, email address, or account name",
        "quickLogin.smsCodePH": "Verification code",
        "quickLogin.emailCodePH": "Verification code",
        "quickLogin.codeBtn": "	Send Code",
        "quickLogin.codeCountdown": "Resend Code ({0}s)",
        "quickLogin.mobileLogin": "Mobile Number Verification",
        "quickLogin.emailLogin": "Email Address Verification",
        "quickLogin.selectUsersTitle": "Select Account",
        "quickLogin.selectUsersTitle.h5": "Select Account",
        "quickLogin.notAllowed": "This account does not support quick login. Use another account.",
        "quickLogin.smsCodeMsg": "Send a verification code to the mobile number {0}.",
        "quickLogin.emailCodeMsg": "Send a verification code to the email address {0}.",
        "quickLogin.noMobile": "This account is not associated with a mobile number. Log in using an email address.",
        "quickLogin.noEmail": "This account is not associated with an email address. Log in using a mobile number.",
        "quickLogin.qucikLoginTip": "This account has been upgraded to a HUAWEI ID. Log in through the HUAWEI ID login page.",
        "quickLogin.notActivate": "This account is not activated, quick login is not allowed",
        "quickLogin.register": "Free Registration",
        
        "ssologin.title": "Select Identity Provider",
        "ssologin.btnTxt": "Access",
    
        "idpLogin.loginLink": "Federated User",
        "idpLogin.title": "Federated User Login",
        "idpLogin.h5SelectTip": "Select Identity Provider",
        "idpLogin.accountPh": "HUAWEI CLOUD account name or tenant name",
        "idpLogin.listPh": "Identity provider",
        "idpLogin.goLogin": "Log In",
        "idpLogin.goAccountLogin": "HUAWEI CLOUD Account",
        "idpLogin.noIdps": "This account is not associated with any identity provider. Enter another account name or tenant name.",
        "idpLogin.domainNotExist": "This account does not exist. Enter another account name or tenant name.",

        'selfManage.alertTip': 'The administrator has disabled Information Self-Management. If you need to modify your information, contact the administrator.',
    };
    function i18n(key) {
        return i18n.framework[key];
    }
    i18n.framework = framework;
    return i18n;
});



// WEBPACK FOOTER //
// ./public/hws/i18n/en-us/resource.js